import api from "../api/axiosInstance.js";

export const handleLogout = async (roleId) => {
  try {
    const response = await api.post("/api/auth/logout");
    if (roleId === 2) {
      window.location.href = "/candidate/login";
    } else {
      window.location.href = "/";
    }
  } catch (error) {
    console.log(error);
  }
};
